import { isFunction } from 'lodash';
import React from 'react';
import { findDOMNode } from 'react-dom';
import { Loader, MediaItemErrorMsg } from 'wix-rich-content-ui-components';
import { s as styleInject } from '../style-inject.es-e7b07dd7.js';
import { ROOT } from '../dataHooks.js';
import { V as VideoViewer } from '../video-viewer-cccd0280.js';
import 'wix-rich-content-common';
import '../IframePlayer.js';
import '../reactPlayerWrapper.js';
import 'wix-react-player';
import '../constants.js';
import 'ricos-schema';

var css_248z = ".B6U2p{height:100%;position:absolute;top:0;width:100%;z-index:0}[dir] .B6U2p{border:0}[dir=ltr] .B6U2p{left:0}[dir=rtl] .B6U2p{right:0}.ReYKU{bottom:0;position:absolute;top:0;z-index:3}[dir=ltr] .ReYKU,[dir=rtl] .ReYKU{left:0;right:0}._7zJI1{height:0;position:relative}[dir] ._7zJI1{padding-bottom:56.25%}@supports not (contain:inline-size){@media only screen and (max-width:640px){._7zJI1{min-width:auto}}}@container (width < 640px){._7zJI1{min-width:auto}}.XNZYs{bottom:0;height:100%;position:absolute;top:0;width:100%;z-index:1}[dir] .XNZYs{cursor:move}.XNZYs~*>*{pointer-events:none}._7Rr7F{height:0;overflow:hidden;visibility:hidden;width:0}.Bbdd-,._7Rr7F{position:absolute}.Bbdd-{align-items:center;color:#fff;display:flex;font-size:20px;font-weight:400;height:100%;justify-content:center;top:0;width:100%;z-index:1}[dir] .Bbdd-{background:rgba(0,0,0,.5);text-align:center}[dir=ltr] .Bbdd-{right:0}[dir=rtl] .Bbdd-{left:0}";
var styles = {"video_player":"B6U2p","videoOverlay":"ReYKU","video_container":"_7zJI1","video_overlay":"XNZYs","hide_duration":"_7Rr7F","error":"Bbdd-"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class VideoComponent extends React.Component {
  constructor(props) {
    super(props);
    this.handleReady = (player) => {
      if (!this.state.isLoaded) {
        this.setState({ isLoaded: true });
      }
      this.handleDuration(player);
    };
    this.handleDuration = (player) => {
      setTimeout(() => {
        var _a;
        const duration = (_a = player.current) == null ? void 0 : _a.getDuration();
        if (duration) {
          this.saveDurationToData(duration);
        } else {
          this.setState({ shouldRenderDurationFix: true });
        }
      }, 3e3);
    };
    this.renderLoader = () => {
      var _a, _b;
      const isCustomVideo = "video" in this.props.componentData && !!((_b = (_a = this.props.componentData.video) == null ? void 0 : _a.src) == null ? void 0 : _b.id);
      return /* @__PURE__ */ React.createElement("div", { className: styles.videoOverlay }, /* @__PURE__ */ React.createElement(
        Loader,
        {
          type: "medium",
          isVerySlowFakeLoader: isCustomVideo,
          percent: this.props.loadingPercentage,
          disableProgress: !this.props.isLoading && !this.state.isLoaded
        }
      ));
    };
    this.saveDurationToData = (duration) => {
      const { componentData, updateAttributes } = this.props;
      const video = "video" in componentData ? componentData.video : {};
      updateAttributes(__spreadProps(__spreadValues({}, componentData), { video: __spreadProps(__spreadValues({}, video || {}), { duration }) }));
    };
    this.renderPlayer = () => {
      const { componentData, settings, nodeId } = this.props;
      return /* @__PURE__ */ React.createElement(
        VideoViewer,
        {
          componentData,
          settings,
          onReady: this.handleReady,
          isLoaded: this.state.isLoaded,
          key: this.state.iosFixKey,
          nodeId,
          isLight: false,
          disabled: true
        }
      );
    };
    this.renderPlayerDurationFix = () => {
      const { componentData, settings, nodeId } = this.props;
      const play = (player) => {
        var _a;
        const internalPlayer = (_a = player.current) == null ? void 0 : _a.getInternalPlayer();
        if (internalPlayer && "play" in internalPlayer && isFunction(internalPlayer.play)) {
          internalPlayer.play();
          return true;
        }
        return false;
      };
      const onReady = (player) => {
        const hasPlayed = play(player);
        if (hasPlayed) {
          return;
        }
        this.durationFixTimeoutId = setTimeout(() => {
          play(player);
        }, 1e4);
      };
      return /* @__PURE__ */ React.createElement("div", { className: styles.hide_duration }, /* @__PURE__ */ React.createElement(
        VideoViewer,
        {
          componentData,
          settings,
          onReady,
          isLight: false,
          onDuration: (duration) => {
            this.setState({ shouldRenderDurationFix: false });
            this.saveDurationToData(duration);
            clearTimeout(this.durationFixTimeoutId);
          },
          nodeId,
          muted: true
        }
      ));
    };
    this.state = {
      isLoaded: false,
      iosFixKey: 1
    };
  }
  componentDidMount() {
    this.handlePlayerFocus();
  }
  componentDidUpdate() {
    this.handlePlayerFocus();
  }
  componentWillUnmount() {
    clearTimeout(this.durationFixTimeoutId);
  }
  handlePlayerFocus() {
    var _a, _b;
    const element = (_b = (_a = findDOMNode(this)) == null ? void 0 : _a.querySelector) == null ? void 0 : _b.call(_a, "iframe, video");
    if (element) {
      element.tabIndex = -1;
    }
  }
  render() {
    const {
      t,
      componentData: { error },
      isLoading
    } = this.props;
    const { isLoaded, shouldRenderDurationFix } = this.state;
    const loading = isLoading || !isLoaded;
    return /* @__PURE__ */ React.createElement("div", { "data-hook": ROOT, className: styles.video_container }, /* @__PURE__ */ React.createElement("div", { className: styles.video_overlay }), this.renderPlayer(), shouldRenderDurationFix ? this.renderPlayerDurationFix() : null, loading && !error && this.renderLoader(), error && /* @__PURE__ */ React.createElement(MediaItemErrorMsg, { error, t }));
  }
}

export { VideoComponent };
//# sourceMappingURL=video-component.js.map
